import TransactionListTable from "./table";

const TransactionList = ({ isAssetsOnly }: { isAssetsOnly?: boolean }) => {
  return <TransactionListTable isAssetsOnly={isAssetsOnly} />;
};

export default TransactionList;
